import React, { useContext, useState, Fragment, useEffect } from "react";
import {
  PageHeading,
  withPageHeading,
  TableOfContents,
  Mui,
  TOC,
} from "@osu/react-ui";
import Routes from "../../Routes/components";
import { useLocation, useNavigate } from "react-router-dom";
import BreadcrumbTrail from "../../Common/components/BreadcrumbTrail";
import ApplicantAppBar from "../../Applicant/components/appBar";
import Navbar from "../../Navbar/components";
import useRoleAuthentication from "../../Common/hooks/useRoleAuthentication";


const styles = {
  root: (theme) => ({
    [theme.breakpoints.up("md")]: {
      display: "flex",
      flexDirection: "row-reverse",
    },
    minHeight: "calc(100vh - var(--nav-height) - var(--footer-height))",
  }),
  toc: (theme) => ({
    zIndex: theme.zIndex.appBar - 2,
  }),
};

function Main({ className = "", unauthorized, loading, spacingTop, paths, tabIndex = "-1", component = "main", ...rest } = {}) {
  const location = useLocation();
  const { exists } = useContext(TOC.Context);
  let navigate = useNavigate();
  const authDetails = useRoleAuthentication();

  useEffect(() => {
    if (authDetails?.HAS_ROLES === false && !location.pathname.includes("/unauthorized")) {
      navigate("/unauthorized");
    }
  }, [authDetails, location.pathname, navigate])


  const [pageAppHeader, setPageAppHeader] = useState({ isLoaded: false });
  const [containerSize, setContainerSize] = useState(false);
  
  return (
    <Fragment>
        {authDetails?.HAS_ROLES && <Navbar>
          {(location.pathname.includes("/applicant") || location.pathname.includes("/view") || (location.pathname.includes("/training") && !location.pathname.includes("/reports/training"))) && ( <ApplicantAppBar pageAppHeader={pageAppHeader} /> )}
        </Navbar>}
      <Mui.Box
        flexGrow={100}
        sx={styles.root}
        className={className}
        {...rest}
      >
        <Mui.Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
          <TableOfContents
            spacingTop={false}
            PaperProps={{
              sx: styles.toc,
            }}
            StylizedLinkProps={{ color: "primary" }}
          />
        </Mui.Box>
        <Mui.Container className="margin-y-4" maxWidth={containerSize}>
          <Mui.Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
            <BreadcrumbTrail />
          </Mui.Box>
          <Mui.Box sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
            <PageHeading variant="h3" />
          </Mui.Box>
          <Mui.Box sx={{ display: { xs: 'block', sm: 'block', md: 'none' } }}>
            <header className="display-flex">
              <PageHeading variant="h3" />
            </header>
            {exists && <TableOfContents variant="popover" PopoverProps={{}} />}
          </Mui.Box>
          <Routes setPageAppHeader={setPageAppHeader} setContainerSize={setContainerSize}/>
        </Mui.Container>
      </Mui.Box>
    </Fragment>
  );
}

export default withPageHeading(Main);
